export enum MerchantTypeEnum {
  Eats = 1,
  Marts = 2,
}
